import { render, staticRenderFns } from "./GroupCompareTable.vue?vue&type=template&id=2eb08131&scoped=true"
import script from "./GroupCompareTable.vue?vue&type=script&lang=js"
export * from "./GroupCompareTable.vue?vue&type=script&lang=js"
import style0 from "./GroupCompareTable.vue?vue&type=style&index=0&id=2eb08131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb08131",
  null
  
)

export default component.exports